import { hasCapability, type User } from "../base";

export const deadline = {
  read: (user: User) => hasCapability(user, "deadline.read"),
  update: (user: User) => hasCapability(user, "deadline.update"),
};
